import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './style.css';
import Login from './pages/Login';
import VerifyPhone from './pages/VerifyPhone';
import EnterCode from './pages/EnterCode';
import TraderDashboard from './pages/TraderDashboard';
import ClientDetail from './pages/ClientDetail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import InviteUser from './pages/InviteUser';
import ProtectedRoute from './pages/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <div className="app-container">
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />

          {/* Authenticated routes — redirect to /login if no session */}
          <Route path="/verify-phone"  element={<ProtectedRoute><VerifyPhone /></ProtectedRoute>} />
          <Route path="/enter-code"    element={<ProtectedRoute><EnterCode /></ProtectedRoute>} />
          <Route path="/trader-dashboard" element={<ProtectedRoute><TraderDashboard /></ProtectedRoute>} />
          <Route path="/client-details/:clientId" element={<ProtectedRoute><ClientDetail /></ProtectedRoute>} />

          {/* Admin-only route */}
          <Route path="/invite-user" element={<ProtectedRoute adminOnly><InviteUser /></ProtectedRoute>} />
        </Routes>
        <ToastContainer position="top-center" autoClose={3000} />
      </div>
    </AuthProvider>
  );
}

export default App;
